var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var hasOwnProperty = Object.hasOwnProperty;
export var id = function (x) { return x; };
export var constant = function (x) { return function () { return x; }; };
export var T = constant(true);
export var F = constant(false);
export var Null = constant(null);
export var clone = function (x) { return JSON.parse(JSON.stringify(x)); };
/**
 * Intentionally using `any` rather than `void` here, so consumers can pretty
 * much use this as a default value for anything they want to without type
 * issue.
 */
export function noop() {
    /* noop */
}
/**
 * Given a constructor, this will return a function that determines if the
 * provided value `x` "is" of the same class or inherits from it.
 *
 * @example
 * is(String)('foobar') // => true
 * is(RegExp)(/^foo/)   // => true
 * is(RegExp)([1, 2])   // => false
 */
export var is = function (C) { return function (x) {
    return x != null && (x.constructor === C || x instanceof C);
}; };
// -------------------------------------------------------------------------- //
// "Lang" Functions
// -------------------------------------------------------------------------- //
export var has = function (o, k) {
    return hasOwnProperty.call(o, k);
};
export var isArray = Array.isArray;
export var isNil = function (x) { return x == null; };
export var isError = is(Error);
export var isString = is(String);
export var isNumber = is(Number);
export var isRegexp = is(RegExp);
export var isFunction = is(Function);
// -------------------------------------------------------------------------- //
// Miscellaneous
// -------------------------------------------------------------------------- //
/**
 * Returns a function that invokes the given function and returns it's return
 * value, but catches any errors thrown. If an error is thrown, it is returned.
 *
 * @example
 * const assertGreaterThan10 = (x) => {
 *   if (x > 10) return true
 *   throw new Error('Oops... you passed 10 or less!')
 * }
 *
 * attempt(assertGreaterThan10, 11) // true
 * attempt(assertGreaterThan10, 2)  // Error
 */
export function attempt(f) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    try {
        return f.apply(void 0, __spread(args));
    }
    catch (e) {
        return e;
    }
}
/**
 * Similar to `attempt`, except that if an error is encountered the given `z`
 * or "fallback" value is returned.
 *
 * @example
 * const getUserID = <T>(user: T): string => {
 *   return user.id
 * }
 *
 * attemptOr('fallback', getUserID, null)           // => 'fallback'
 * attemptOr('fallback', getUserID, { id: '1234' }) // => '1234'
 */
export function attemptOr(z, f) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var result = attempt.apply(void 0, __spread([f], args));
    return isError(result) ? z : result;
}
/**
 * Creates a function that wraps the given string with the provided `char`.
 * Will escape all instances of `char` in the string with `\`.
 */
export function characterWrapper(char) {
    var re = new RegExp("(" + char + ")", 'g');
    return function (x) { return "" + char + x.replace(re, '\\$1') + char; };
}
export var singleQuote = characterWrapper("'");
export var doubleQuote = characterWrapper('"');
/**
 * Since the `code` property doesn't exist in DOM, this creates an Error
 * object with a code property. Additionally, it has a `toJSON` property that
 * will properly serialize the thing (with name and stack) as JS errors do not
 * properly serialize.
 */
var ErrorWithCode = /** @class */ (function (_super) {
    __extends(ErrorWithCode, _super);
    function ErrorWithCode(code, message) {
        var _this = _super.call(this, message) || this;
        /**
         * Returns this Error as a plain object.
         * Can't do this on prototype (at least Node.js doesn't like it), so using
         * an auto-bound function.
         */
        _this.toJSON = function () {
            return {
                code: _this.code,
                name: _this.name,
                stack: _this.stack,
                message: _this.message,
            };
        };
        _this.code = code;
        return _this;
    }
    return ErrorWithCode;
}(Error));
export { ErrorWithCode };
/**
 * Strips HTML tags from the given string. For example
 * stripHTMLTags('<span>test</span>') // returns 'test'
 */
export function stripHTMLTags(str) {
    var removeHTMLTag = /(<([^>]+)>)/gi;
    return str.replace(removeHTMLTag, '');
}
/**
 * Asserts that `cond` is truthy.
 * If not, an AssertionError is thrown.
 *
 * @example
 * assert(true, 'No error thrown here...')
 * assert(false, 'This will throw!')
 */
export function assert(cond, msg) {
    if (msg === void 0) { msg = 'Assertion Error'; }
    if (!cond) {
        throw Object.assign(new Error(msg), {
            name: 'AssertionError',
        });
    }
}
//# sourceMappingURL=util.js.map